module.exports = __webpack_public_path__ + "media/images/athletes/2115-16951047b401a8413ef9acf96bc1eee4.png";